<template>
  <BaseLimitManagement
    :items="items"
    :selected="itemsSelected"
    :loading="loading"
    @delete="deleteSelected"
  >
    <template v-slot:listItem="{ item }">
      <v-checkbox
        :input-value="item.selected"
        @change="selectItem(item)"
      ></v-checkbox>
      <div>
        {{ item.user.email }}
      </div>
    </template>
  </BaseLimitManagement>
</template>

<script>
import limitsService from "@/services/limits";
import BaseLimitManagement from "./BaseLimitManagement.vue";
import { limitsMixin } from "@/helpers/mixins/limits";

export default {
  name: "UsersListManagement",
  components: {
    BaseLimitManagement
  },
  mixins: [limitsMixin],
  methods: {
    itemsFetchHandler() {
      return limitsService.getMembers();
    },
    itemDeleteHandler(id) {
      return limitsService.deleteMember(id);
    }
  },
  computed: {
    selectedItemsIds() {
      return this.items.filter(item => item.selected).map(item => item.user.id);
    }
  }
};
</script>
